import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const getDefaultItemLine = () =>({
    qty: 1,
    inventory: null,
    prices: [],
    product: null,
    productTaxes: null,
    discount: null,
    subTotal: 0.00,
    subTotalBrut: 0.00,
    total: 0.00,
    // qty_ordered : 1,
    // productId:null,
    // discount : {
    //   value:null,
    //   type :null,
    //   amount : null,
    //   netType : null,
    //   creditType : null,
    // },
    // price : null,
    // errorCode : "NO_ERROR",
    // inventoryId : null,
    // prices : [],
    // sku : null,
    // sub_total : 0.00,
    // sub_total_brut : 0.00,
    // unit : null,
    // uuid : null,
    // quantityAvailable: null,
    // validations : [],
    // quantities : null,
    // credit : null,
    // type : null,
})

const getDefaultState = () => ({
  salesOrder : {
    id : null,
    customer : null,
    billingContact : null,
    shippingContact : null,
    soNumber : null,
    billingAddress : null,
    shippingAddress : null,
    billingContact: null,
    date : null,
    expectedDeliveryDate : null,
    setDeliveryMethodAsDefault : false,
    setDeliveryLocationAsDefault: false,
    deliveryFee : 0.00,
    deliveryType:null,
    extraInfo : {
      location : null
    },
    rep : null,
    lines : [],
    // status : {},
    credit : 0,
    notes : '',
    reference : '',
    paidByAgent: false,
    subTotal : 0.00,
    total : 0.00,
    taxes : [],
    detailItemsLoading : false,
    tags : [],
    discount: null,
    subTotalBillable: null,
  },
  tagsOutDated : true,
  listTags : [],
  indUpdateInvoice : false,
  defaultItem : getDefaultItemLine(),
  searchedCustomers : [],
  customerContacts : [],
  itemsLoading : false,
  customerReservations : [],
  repAllocations: [],
  customerReservationLoading : false,
  dateRequired : false,
  dateError : null,
  showDeliveryLocation : false,
  locationsList : [],
  loading : false,
  locationName : '',
});



export default {
  namespaced: true,
  state: getDefaultState(),
  actions,
  getters,
  mutations,
  getDefaultState,
};
